import Nav from './Nav'
import MobileNav from './MobileNav'
import { useAuth } from '@/hooks/useAuth'

/**
 * PageWrapper — wraps every authenticated page.
 *
 * Props:
 *   title         — shown in Nav center (mobile)
 *   showBack      — show back arrow in Nav
 *   onBack        — override back behaviour
 *   hideNav       — hide the top nav entirely (full-screen pages)
 *   hideMobileNav — hide the bottom tab bar
 *   transparent   — transparent top nav (for hero sections)
 *   maxWidth      — container max-width class (default: max-w-lg)
 *   noPad         — remove horizontal padding (full-bleed)
 *   className     — extra classes on the content area
 */
export default function PageWrapper({
  children,
  title,
  showBack = false,
  onBack,
  hideNav = false,
  hideMobileNav = false,
  transparent = false,
  maxWidth = 'max-w-lg',
  noPad = false,
  className = '',
}) {
  const { profile } = useAuth()
  const showBottomNav = profile && !hideMobileNav

  return (
    <div className="min-h-dvh flex flex-col bg-surface-base">
      {/* Top Nav */}
      {!hideNav && (
        <Nav
          title={title}
          showBack={showBack}
          onBack={onBack}
          transparent={transparent}
        />
      )}

      {/* Page Content */}
      <main className={`
        flex-1
        ${showBottomNav ? 'pb-24' : ''}
        ${!noPad ? `w-full ${maxWidth} mx-auto px-4` : ''}
        ${className}
      `}>
        {children}
      </main>

      {/* Bottom Mobile Nav */}
      {showBottomNav && <MobileNav />}
    </div>
  )
}
